import type { Renderer2 } from '@angular/core';
import { Injectable, RendererFactory2, inject, DOCUMENT } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { CookieService } from 'ngx-cookie-service';
import { GTM_MODULE_TOKEN } from './gtm.module.token';

@Injectable()
export class GoogleAnalyticsApiService {
    protected http = inject(HttpClient);
    protected cookieService = inject(CookieService);
    protected rendererFactory = inject(RendererFactory2);
    protected document = inject<Document>(DOCUMENT);
    private appPath = inject(GTM_MODULE_TOKEN);

    private url = '/members/ajax/data-layer';
    private isInitGTM: boolean = false;
    private renderer: Renderer2;

    constructor() {
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    public getDataLayer(url: string): Observable<any> {
        return this.http.post(`${location.origin}${this.url}`, { url: `${this.appPath}${url}` }).pipe(
            map((res) => {
                return res;
            }),
            catchError((error) => throwError(error))
        );
    }

    public initializeGTM(dataLayer: Array<any>) {
        if (this.isInitGTM) {
            return;
        }

        const headScript = this.renderer.createElement('script');
        headScript.text = `dataLayer = [${JSON.stringify(
            dataLayer
        )}];(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://data.sendpulse.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f)})(window,document,'script','dataLayer','GTM-NQT4SH')`;

        this.renderer.appendChild(this.document.head, headScript);
        this.isInitGTM = true;
    }
}
